// removed by extract-text-webpack-plugin
module.exports = {"need_photosesh":"_2a7PtDj3SGgghLXXPb0OP2","container":"vZGYwyqpWZF1nvMpyWFCI","custom_image":"_2ojCe6Eiea-xsabZR2J2hC","custom_card":"_313tt20IozzQ68ztyclD3n","custom_detail_light":"_3cB3DbeQy2E8CUB3Kkozys","item":"_1uNet8swBn4fi5nKMeqzR5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/need_photosesh.css
// module id = 3018
// module chunks = 0